export const categories = [
  { name: 'Shoes', href: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { name: 'Hoodies/Sweaters', href: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'T-Shirts', href: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'Jackets', href: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-t-shirt-air-line' },
  { name: 'Pants/Shorts', href: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-t-shirt-2-line' },
  { name: 'Headwear', href: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-service-line' },
  { name: 'Sets', href: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { name: 'Underwear/Underpants', href: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-shield-star-line' },
  { name: 'Jersey', href: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Accessories', href: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-vip-diamond-line' },
  { name: 'Bags', href: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-shopping-bag-line' },
  { name: 'Belts', href: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-links-line' },
  { name: 'Perfumes', href: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
  { name: 'Other Stuff', href: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
] as const;

export const resources = [
  {
    key: 'resourceSpreadsheet',
    slug: 'spreadsheet',
    icon: 'ri-table-line',
  },
  {
    key: 'resourceReviews',
    slug: 'reviews',
    icon: 'ri-star-line',
  },
  {
    key: 'resourceShipping',
    slug: 'shipping',
    icon: 'ri-truck-line',
  },
  {
    key: 'resourceWarehouse',
    slug: 'warehouse',
    icon: 'ri-building-2-line',
  },
  {
    key: 'resourceCoupons',
    slug: 'coupons',
    icon: 'ri-coupon-line',
  },
  {
    key: 'resourceDiscounts',
    slug: 'discounts',
    icon: 'ri-percent-line',
  },
  {
    key: 'resourceLegit',
    slug: 'legit',
    icon: 'ri-shield-check-line',
  },
  {
    key: 'resourceQC',
    slug: 'qc',
    icon: 'ri-search-eye-line',
  },
] as const;

export const popularCategories = [
  { key: 'categoryClothing', image: 'https://readdy.ai/api/search-image?query=Minimalist%20fashion%20clothing%20flatlay%20on%20light%20linen%20background%2C%20soft%20natural%20light%2C%20neutral%20tones%2C%20editorial%20product%20photography%2C%20clean%20aesthetic%2C%20high%20detail&width=400&height=300&seq=cat-clothing&orientation=landscape' },
  { key: 'categoryShoes', image: 'https://readdy.ai/api/search-image?query=Stylish%20sneakers%20on%20clean%20white%20background%2C%20soft%20studio%20light%2C%20minimalist%20product%20photography%2C%20neutral%20colors%2C%20editorial%20style%2C%20high%20detail%20close%20up&width=400&height=300&seq=cat-shoes&orientation=landscape' },
  { key: 'categoryAccessories', image: 'https://readdy.ai/api/search-image?query=Minimal%20jewelry%20and%20accessories%20arrangement%20on%20soft%20pastel%20surface%2C%20natural%20light%2C%20clean%20editorial%20product%20photography%2C%20neutral%20tones%2C%20high%20detail&width=400&height=300&seq=cat-accessories&orientation=landscape' },
  { key: 'categoryElectronics', image: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20tech%20gadgets%20on%20light%20wood%20surface%2C%20soft%20natural%20light%2C%20clean%20product%20photography%2C%20neutral%20tones%2C%20editorial%20style%2C%20high%20detail&width=400&height=300&seq=cat-electronics&orientation=landscape' },
  { key: 'categoryBags', image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20leather%20bag%20on%20light%20neutral%20background%2C%20soft%20studio%20light%2C%20clean%20product%20photography%2C%20editorial%20style%2C%20high%20detail%20close%20up&width=400&height=300&seq=cat-bags&orientation=landscape' },
  { key: 'categoryStreetwear', image: 'https://readdy.ai/api/search-image?query=Urban%20streetwear%20fashion%20flatlay%20on%20concrete%20surface%2C%20soft%20natural%20light%2C%20neutral%20tones%2C%20editorial%20product%20photography%2C%20clean%20aesthetic%2C%20high%20detail&width=400&height=300&seq=cat-streetwear&orientation=landscape' },
  { key: 'categoryHome', image: 'https://readdy.ai/api/search-image?query=Minimalist%20home%20decor%20and%20lifestyle%20products%20on%20light%20wood%20shelf%2C%20soft%20natural%20light%2C%20neutral%20tones%2C%20editorial%20product%20photography%2C%20clean%20aesthetic&width=400&height=300&seq=cat-home&orientation=landscape' },
  { key: 'categoryPopular', image: 'https://readdy.ai/api/search-image?query=Trending%20fashion%20items%20arrangement%20on%20light%20marble%20surface%2C%20soft%20natural%20light%2C%20neutral%20tones%2C%20editorial%20product%20photography%2C%20clean%20aesthetic%2C%20high%20detail&width=400&height=300&seq=cat-popular&orientation=landscape' },
  { key: 'categorySellers', image: 'https://readdy.ai/api/search-image?query=Professional%20business%20supplies%20and%20packaging%20materials%20on%20clean%20desk%2C%20soft%20natural%20light%2C%20neutral%20tones%2C%20editorial%20product%20photography%2C%20clean%20aesthetic&width=400&height=300&seq=cat-sellers&orientation=landscape' },
  { key: 'categoryQC', image: 'https://readdy.ai/api/search-image?query=Quality%20inspection%20tools%20and%20magnifying%20glass%20on%20light%20background%2C%20soft%20studio%20light%2C%20clean%20product%20photography%2C%20neutral%20tones%2C%20editorial%20style%2C%20high%20detail&width=400&height=300&seq=cat-qc&orientation=landscape' },
] as const;